import React, { useState } from "react";

type TextUnitProps = {
  id: string | number;
  object: {
    x: number;
    y: number;
    width: number;
    height: number;
    transcription: string;
  };
  selectedTerm?: string;
};

const TextUnit: React.FC<TextUnitProps> = ({ object, id, selectedTerm }) => {
  const [hovered, setHovered] = useState(false);

  // Check if this text unit matches the selected term (case-insensitive, trimmed)
  const isSelected =
    selectedTerm &&
    object.transcription.toLowerCase().includes(selectedTerm.toLowerCase());

  return (
    <div
      className={`absolute box-border z-10 transition-all duration-300 ${
        isSelected
          ? "bg-yellow-400/40 shadow-lg"
          : "bg-red-400/25"
      }`}
      style={{
        left: `${object.x}px`,
        top: `${object.y}px`,
        width: `${object.width}px`,
        height: `${object.height}px`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && (
        <div
          className="absolute bottom-full left-1/2 mb-px -translate-x-1/2 z-[100]
                              bg-[#050607] text-white text-xs px-2 py-1 rounded shadow-lg
                              whitespace-nowrap transition-opacity z-50"
        >
          <p className="text-[10px]">{object.transcription}</p>
        </div>
      )}
    </div>
  );
};

export default TextUnit;
